export const SET_SORT = 'ClubCardModal/SET_SORT'

export const SORT_COLUMNS = {
  APPLICATION: 'clubCards@Current',
  NO: 'no',
  COMPANY: 'company',
  SHARE_CLUB_CARD: 'shareClubCard',
  NEW_CLUB_CARDS: 'clubCardsCurrent',
}
